import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { useMobileOS } from '@beef/react';
import { OS } from "../../../../shared/types";
import { handleBodyScroll } from "./helper";
export var useFixedBodyScroll = function useFixedBodyScroll(isOpenChat, isMobile) {
  var mobileOS = useMobileOS();
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isFirstRender = _useState2[0],
    setIsFirstRender = _useState2[1];
  var isIOS = isMobile && mobileOS === OS.ios;
  useEffect(function () {
    var position = document.documentElement.scrollTop;
    if (isIOS) {
      if (isOpenChat) {
        handleBodyScroll.lock(position);
        setIsFirstRender(false);
      } else if (!isFirstRender) {
        handleBodyScroll.unlock(position);
      }
    }
    return function () {
      handleBodyScroll.unlock(position || 0);
    };
  }, [isOpenChat, isMobile, isIOS]);
};